import { normalizeTimestamp } from '../lib/normalize-timestamp';

const ASSISTANT_REPLY_OFFSET_MS = 1000;

export const createMessage = (
	type,
	text,
	timestamp = new Date().toISOString(),
) => ({
	id: crypto.randomUUID(),
	type,
	text,
	timestamp,
});

export const toChatMessages = history =>
	history.flatMap(({ message, response, timestamp }) => {
		const userTime = new Date(normalizeTimestamp(timestamp));
		const assistantTime = new Date(
			userTime.getTime() + ASSISTANT_REPLY_OFFSET_MS,
		);
		return [
			createMessage('user', message, userTime.toISOString()),
			createMessage('assistant', response, assistantTime.toISOString()),
		];
	});
